import script from "./PeerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PeerPage.vue?vue&type=script&setup=true&lang=js"

import "./PeerPage.vue?vue&type=style&index=0&id=6dba3b26&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dba3b26"]])

export default __exports__